export const drawer = {
  colorScheme: {
    border: {
      color: 'none',
      width: 0,
    },
    light: {
      background: '{surface.300}',
      color: '{neutral.900}',
      borderColor: '{surface.300}',
    },
    dark: {
      background: '#424657',
      color: 'white',
      border: {
        color: '#424657',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
      .p-drawer-right {
        width: 27rem;
      }
    `,
};
